export enum AbTestTypeCategory {
  SHIPPING_RATES = 'SHIPPING_RATES',
  EXTENSIONS = 'EXTENSIONS',
  CROSS_SITE = 'CROSS_SITE',
  PRODUCT_PAGE = 'PRODUCT_PAGE',
  EXTENSIONS_GROUPS = 'EXTENSIONS_GROUPS',
  SMART_CART = 'SMART_CART',
  CHECKOUT_PROFILE = 'CHECKOUT_PROFILE',
}

export enum AbTestWidgetType {
  CHECKOUT = 'checkout',
  EXTENSION = 'extension',
  CROSS_SITE = 'cross_site',
  PRODUCT_PAGE = 'product_page',
  EXTENSION_GROUPS = 'extension_groups',
  SMART_CART = 'smart_cart',
  CHECKOUT_PROFILE = 'checkout_profile',
}

export const AbTestWidgetTypeLabels = {
  [AbTestTypeCategory.SHIPPING_RATES]: 'Shipping Rates',
  [AbTestTypeCategory.EXTENSIONS]: 'Extensions',
  [AbTestTypeCategory.CROSS_SITE]: 'Cross-Site',
  [AbTestTypeCategory.PRODUCT_PAGE]: 'Product Page',
  [AbTestTypeCategory.EXTENSIONS_GROUPS]: 'Extensions Groups',
  [AbTestTypeCategory.SMART_CART]: 'Smart Cart',
  [AbTestTypeCategory.CHECKOUT_PROFILE]: 'Checkout profile',
  [AbTestWidgetType.CHECKOUT]: 'Shipping Rates',
  [AbTestWidgetType.EXTENSION]: 'Extensions',
  [AbTestWidgetType.CROSS_SITE]: 'Cross-Site',
  [AbTestWidgetType.PRODUCT_PAGE]: 'Product Page',
  [AbTestWidgetType.SMART_CART]: 'Smart Cart',
  [AbTestWidgetType.CHECKOUT_PROFILE]: 'Checkout profile',
};

export const AbTestTypeCategoryLabels = {
  [AbTestTypeCategory.SHIPPING_RATES]: 'Shipping Rates Test',
  [AbTestTypeCategory.EXTENSIONS]: 'Extensions Test',
  [AbTestTypeCategory.CROSS_SITE]: 'Cross-Site Test',
  [AbTestTypeCategory.PRODUCT_PAGE]: 'Product Page Test',
  [AbTestTypeCategory.EXTENSIONS_GROUPS]: 'Extensions Groups Test',
  [AbTestTypeCategory.SMART_CART]: 'Smart Cart Test',
  [AbTestTypeCategory.CHECKOUT_PROFILE]: 'Checkout Profile Test',
};

export const AbTestTypeCategoryToWidgetType = {
  [AbTestTypeCategory.SHIPPING_RATES]: AbTestWidgetType.CHECKOUT,
  [AbTestTypeCategory.EXTENSIONS]: AbTestWidgetType.EXTENSION,
  [AbTestTypeCategory.CROSS_SITE]: AbTestWidgetType.CROSS_SITE,
  [AbTestTypeCategory.PRODUCT_PAGE]: AbTestWidgetType.PRODUCT_PAGE,
  [AbTestTypeCategory.EXTENSIONS_GROUPS]: AbTestWidgetType.EXTENSION_GROUPS,
  [AbTestTypeCategory.SMART_CART]: AbTestWidgetType.SMART_CART,
  [AbTestTypeCategory.CHECKOUT_PROFILE]: AbTestWidgetType.CHECKOUT_PROFILE,
};

export const AbTestWidgetTypeToTypeCategory = {
  [AbTestWidgetType.CHECKOUT]: AbTestTypeCategory.SHIPPING_RATES,
  [AbTestWidgetType.EXTENSION]: AbTestTypeCategory.EXTENSIONS,
  [AbTestWidgetType.CROSS_SITE]: AbTestTypeCategory.CROSS_SITE,
  [AbTestWidgetType.PRODUCT_PAGE]: AbTestTypeCategory.PRODUCT_PAGE,
  [AbTestWidgetType.EXTENSION_GROUPS]: AbTestTypeCategory.EXTENSIONS_GROUPS,
  [AbTestWidgetType.SMART_CART]: AbTestTypeCategory.SMART_CART,
  [AbTestWidgetType.CHECKOUT_PROFILE]: AbTestTypeCategory.CHECKOUT_PROFILE,
};

export const AbTestTypeCategoryToModalTitle = {
  [AbTestTypeCategory.SHIPPING_RATES]: 'Create Shipping Rates Test',
  [AbTestTypeCategory.EXTENSIONS]: 'Create Extension Test',
  [AbTestTypeCategory.CROSS_SITE]: 'Create Cross-Site Test',
  [AbTestTypeCategory.PRODUCT_PAGE]: 'Create Product Page Test',
  [AbTestTypeCategory.EXTENSIONS_GROUPS]: 'Create Extensions Groups Test',
  [AbTestTypeCategory.SMART_CART]: 'Create Smart Cart Test',
  [AbTestTypeCategory.CHECKOUT_PROFILE]: 'Create Checkout Profile Test',
};

export const AbTestTypeCategoryToDropdownOptions = [
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.SHIPPING_RATES],
    value: AbTestTypeCategory.SHIPPING_RATES,
  },
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.EXTENSIONS],
    value: AbTestTypeCategory.EXTENSIONS,
  },
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.CROSS_SITE],
    value: AbTestTypeCategory.CROSS_SITE,
  },
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.PRODUCT_PAGE],
    value: AbTestTypeCategory.PRODUCT_PAGE,
  },
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.EXTENSIONS_GROUPS],
    value: AbTestTypeCategory.EXTENSIONS_GROUPS,
  },
  {
    label: AbTestTypeCategoryLabels[AbTestTypeCategory.CHECKOUT_PROFILE],
    value: AbTestTypeCategory.CHECKOUT_PROFILE,
  },
  // {
  //   label: AbTestTypeCategoryLabels[AbTestTypeCategory.SMART_CART],
  //   value: AbTestTypeCategory.SMART_CART,
  // },
];
